import { DialogContent, DialogTitle, Typography, Dialog, Grid, Button } from '@material-ui/core';
import React from 'react'

export const ModalMensajeAfiliado = (props) => {

    
    return (
        <Dialog
            fullWidth
            maxWidth={"sm"}
            open={props.open}
            style={{ height: 700, marginTop: -25 }}
            // onClose={props.onClose}
            aria-labelledby="form-dialog-title"
        >
            <DialogTitle id="form-dialog-title">
                <h2
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        margin: "0",
                    }}
                >
                </h2>
            </DialogTitle>
            <DialogContent>
                <Grid item xs={12} sm={12} md={12} lg={12} style={{ paddingLeft: 16, display: 'flex', justifyContent: 'center' }}>
                    <Typography variant="h6">
                      {`El beneficiaria/o ${(props.usuarioTurnoSeleccionado?.afiliado?.apellido_y_nombre)} debe regularizar su situación con la obra social.`}
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} style={{ paddingLeft: 16, display: 'flex', justifyContent: 'center' }}>
                    <div
                        style={{
                            margin: '2rem 0',
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-evenly',
                            width: '50%',  // Ajusta el ancho según tus necesidades
                        }}
                    >
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={props.onClose}
                        >
                            Cerrar
                        </Button>
                    </div>
                </Grid>
            </DialogContent>
        </Dialog>
    )
}
